import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/marketing";

export const getAllMarketing = () => axios.get(API_PATH + "/get-all");

export const pagingMarketing = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getMarketingById = (id) => axios.get(API_PATH + "/get-by-id/" + id);

export const saveMarketing = obj => axios.post(API_PATH + '/save', obj);
 
export const deleteMarketing = id => axios.delete(API_PATH + '/mark-delete/' + id)
